import { AppTrackingTransparency } from "@capgo/capacitor-app-tracking-transparency";
import { Capacitor } from "@capacitor/core";
import { isAppInForeground, isIosPlatform } from "utils/platform.helpers";

/** The plugin's registered JS name; an iOS binary built before the plugin shipped does not have it. */
const ATT_PLUGIN_NAME = "AppTrackingTransparency";

let decision: Promise<boolean> | undefined;

/** Only iOS asks: Apple requires the App Tracking Transparency prompt before any tracking. */
export const requiresTrackingAuthorization = (): boolean => isIosPlatform();

async function resolveAuthorization(): Promise<boolean> {
  if (!Capacitor.isPluginAvailable(ATT_PLUGIN_NAME)) return false;
  try {
    let { status } = await AppTrackingTransparency.getStatus();
    // iOS only shows the prompt while the app is active; otherwise it answers notDetermined.
    if (status === "notDetermined" && (await isAppInForeground())) {
      ({ status } = await AppTrackingTransparency.requestPermission());
    }
    if (status === "notDetermined") decision = undefined;
    return status === "authorized";
  } catch {
    console.warn("App Tracking Transparency is unavailable; ad tags stay off.");
    decision = undefined;
    return false;
  }
}

/**
 * Asks the patient once per launch, and only when called, so the prompt never appears for a
 * practice that set no ad tags. Anything other than `authorized` (denied, restricted, not yet
 * answered, or a binary or plugin that cannot ask) means no ad tag may load. Never rejects.
 */
export function requestTrackingAuthorization(): Promise<boolean> {
  decision ??= resolveAuthorization();
  return decision;
}
